import {
  Inject,
  Magnification,
  Navigation,
  PdfViewerComponent,
  Print,
  TextSearch,
  TextSelection,
  Toolbar,
} from "@syncfusion/ej2-react-pdfviewer";
import { PDFViewerDocument } from "./PDFViewer.types";
import React from "react";
import documentService from "services/documentService";
import styles from "./SyncFusionPdfViewer.module.scss";
import { CircularProgress, Stack } from "@mui/material";

export type SyncfusionPdfViewerProps = {
  document: PDFViewerDocument;
  accessToken: string;
};
export function SyncfusionPdfViewer({
  document,
  accessToken,
}: SyncfusionPdfViewerProps) {
  function handlePrintStart(documentId: string) {
    documentService.trackPrintStarted$(documentId).subscribe();
  }
  function handleDownloadStart(documentId: string) {
    documentService.trackDownloadStarted$(documentId).subscribe();
  }

  if (!accessToken) {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <CircularProgress size={50} />
      </Stack>
    );
  }

  return (
    <PdfViewerComponent
      documentPath={document.documentPath}
      serviceUrl={document.serviceUrl}
      className={styles.viewer}
      printStart={handlePrintStart.bind({}, document.documentPath)}
      downloadStart={handleDownloadStart.bind({}, document.documentPath)}
      ajaxRequestSettings={{
        ajaxHeaders: [
          {
            headerName: "Authorization",
            headerValue: `Bearer ${accessToken}`,
          },
        ],
      }}
    >
      <Inject
        services={[
          Toolbar,
          Magnification,
          Navigation,
          Print,
          TextSelection,
          TextSearch,
        ]}
      />
    </PdfViewerComponent>
  );
}
